import { BankOutlined } from '@ant-design/icons';

import { BillingAccessGuard } from '@app/access/components/BillingAccessGuard';
import { Page } from '@app/components';
import { BILLING, BILLING_LABEL } from '@app/constants/navigation';
import { IframePage } from '@app/pages/IframePage';
import type { NNavigation } from '@app/types';

const BILLING_HOST = process.env.REACT_APP_BILLING_HOST || '';

export const billingPage: NNavigation.NavigationItem = {
  key: BILLING,
  icon: <BankOutlined />,
  label: BILLING_LABEL,
  id: BILLING,
  'data-testid': 'billing',
  path: '/billing/*',
  title: '',
  issidebaritem: 'true',
  sidebarparentid: BILLING,
  element: (
    <Page disableBreadcrumbs hideBackButton>
      <BillingAccessGuard>
        <IframePage host={BILLING_HOST} />
      </BillingAccessGuard>
    </Page>
  ),
};
